import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2c770fff")

_pushScopeId("data-v-2c770fff")
const _hoisted_1 = { class: "chang-mind" }
const _hoisted_2 = { class: "wrapper-top" }
const _hoisted_3 = { class: "img" }
const _hoisted_4 = { class: "wrapper-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_the_service_item = _resolveComponent("the-service-item")
  const _component_list = _resolveComponent("list")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("img", {
          src: require('@/assets/image/瑞兹.png'),
          alt: ""
        }, null, 8, ["src"])
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_list, {
        ref: "list",
        class: "list",
        onOnLoad: $setup.onLoad,
        onOnRefresh: $setup.onRefresh
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.state.list, (item) => {
            return (_openBlock(), _createBlock(_component_the_service_item, {
              key: item.id,
              item: item
            }, null, 8, ["item"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["onOnLoad", "onOnRefresh"])
    ])
  ]))
})